// extracted by mini-css-extract-plugin
module.exports = {"lia-followers-count":"UserFollowersCount_lia-followers-count__uN32E"};